"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowConditionEnum = void 0;
var WorkflowConditionEnum;
(function (WorkflowConditionEnum) {
    WorkflowConditionEnum["NET_AMOUNT"] = "NET_AMOUNT";
    WorkflowConditionEnum["VENDOR"] = "VENDOR";
    WorkflowConditionEnum["COST_CENTER"] = "COST_CENTER";
    WorkflowConditionEnum["REQUESTER"] = "REQUESTER";
    WorkflowConditionEnum["COST_CENTER_2"] = "COST_CENTER_2";
    WorkflowConditionEnum["EXPENSE_KIND"] = "EXPENSE_KIND";
})(WorkflowConditionEnum || (exports.WorkflowConditionEnum = WorkflowConditionEnum = {}));
